import React, { useState } from 'react';

import UrlDialog from 'components/UrlDialog';
import InventoryEditDialog from 'components/InventoryEditDialog';
import FeaturedMatches from './Matches/FeaturedMatches';
import PerfectMatchList from './Matches/PerfectMatchList';
import FollowingList from './Matches/FollowingList';
import CloseMatches from './Matches/CloseMatches';

const DiscoverGigs = () => {
  const [followingList, setFollowingList] = useState([]);

  const updateFollowingList = gig => {
    if (gig.following) {
      setFollowingList(prevState => [...prevState, gig]);
    } else {
      setFollowingList(prevState => prevState.filter(g => g.id !== gig.id));
    }
  };

  return (
    <>
      <FeaturedMatches updateFollowingList={updateFollowingList} />

      <PerfectMatchList updateFollowingList={updateFollowingList} />

      <CloseMatches updateFollowingList={updateFollowingList} />

      <FollowingList followingList={followingList} setFollowingList={setFollowingList} />

      <UrlDialog />

      <InventoryEditDialog />
    </>
  );
};

export default DiscoverGigs;
